// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,
  serverUrl: 'https://datadeliveryplatform-api.vizientinc.com',
  versionNumber:'1.2.250-Develop',
  apiUrl:'https://dataexchangeplatform-api.dev.vizientinc.com',
  termsUrl:'http://vizientinc.com',
  brandUrl:'http://vizientinc.com',
  clientId: '0oa109r59oisJYOEM0x8',
  issuer: 'https://login.alliancewebs.net/oauth2/ausmkot3jmgtQXrtZ0x7',
  redirectUri: '/login/callback',
  pkce: true,

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
